import createCachedSelector from 're-reselect';

import { isEditPublisher, isPraisePublisher } from '../../state/publishers/types';
import type { Publisher, YammerState } from '../../state/types';

import { findByIdThrows as findPublisher } from './findPublisherSelectors';

const emptyPraisedUserIds: string[] = [];

type GetPraisedUserIds = (state: YammerState, publisherId: Publisher['id']) => string[];
export const getPraisedUserIds: GetPraisedUserIds = createCachedSelector(findPublisher, (publisher) => {
  if (!isPraisePublisher(publisher) && !isEditPublisher(publisher)) {
    return emptyPraisedUserIds;
  }

  return publisher.praisedUserIds ?? emptyPraisedUserIds;
})((_state, id) => id);

type HasPraisedUsers = (state: YammerState, publisherId: Publisher['id']) => boolean;
export const hasPraisedUsers: HasPraisedUsers = (state, publisherId) =>
  getPraisedUserIds(state, publisherId).length > 0;
